export function buildUrl(blobUrl: string, sas: string, resourceUrl: string) {
    return resourceUrl;
//    let tokens: string[] = resourceUrl.split('/');
//    return blobUrl + '/' + tokens[tokens.length - 1] + '?' + sas;
}